interface FeatureItem {
  id: number;
  icon: string;
  title: string;
  desc: string;
}

const features: FeatureItem[] = [
  {
    id: 1,
    icon: 'ri-smartphone-line',
    title: '下拉式丝滑阅读',
    desc: '独创香香漫画免费下拉模式，像刷短视频一样流畅阅读漫画，无需翻页，沉浸追更体验拉满。',
  },
  {
    id: 2,
    icon: 'ri-database-2-line',
    title: '海量漫画资源库',
    desc: '香香漫画大全免费收录10万+漫画作品，涵盖全品类题材，好看的漫画免费全集尽在其中。',
  },
  {
    id: 3,
    icon: 'ri-flashlight-line',
    title: '极速加载高清画质',
    desc: 'CDN全球加速配合智能压缩技术，确保香香漫画免费看时画质清晰、加载飞快，弱网也能流畅阅读。',
  },
  {
    id: 4,
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    desc: '热门连载每日实时更新，与官方同步。香香漫画全集免费追更，不错过任何精彩章节。',
  },
  {
    id: 5,
    icon: 'ri-shield-check-line',
    title: '免费安全无忧',
    desc: '全部漫画资源免费开放，无需注册付费。严格内容审核机制，为读者打造纯净安全的阅读环境。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">平台特色</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">为什么千万读者选择香香漫画</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer text-center"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-4 rounded-xl bg-accent-100 flex items-center justify-center transition-transform duration-200 group-hover:scale-110">
                <i className={`${item.icon} text-xl md:text-2xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-2 whitespace-nowrap">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}